/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 打印校验
export const printCheck = (data) => {
    return request({
        url: `/api-tms/dispatch/printCheck`,
        method: 'get',
        params: data
    });
};

// 头部查询
export const getDispathOrderLists = (data) => {
    return request({
        url: `/api-tms/dispatch/search`,
        method: 'post',
        data
    });
};

// 发车单管理编辑
export const getDispathOrderEdit = (data) => {
    return request({
        url: `/api-tms/dispatch/${data.dispatchNo}`,
        method: 'get',
        data
    });
};

// 到车
export const getDispathOrderRegister = (data) => {
    return request({
        url: `/api-tms/dispatch/updatearrive`,
        method: 'put',
        data
    });
};

// 取消到车
export const getDispathOrderNoRegister = (data) => {
    return request({
        url: `/api-tms/dispatch/cancelarrive`,
        method: 'put',
        data
    });
};

// 取消发车单
export const getDispathOrderNoInitiationSlip = (data) => {
    return request({
        // url: `/api-tms/dispatch/canceldepart`,
        url: `/api-tms/intelligent/cancel`,
        method: 'put',
        data
    });
};

// 发车
export const getDispathOrderStart = (data) => {
    return request({
        url: `/api-tms/dispatch/updatedepart`,
        method: 'put',
        data
    });
};

// 获取仓库信息
export const getDispathOrderPrinting = (params) => {
    return request({
        url: `/api-tms/dispatch/warehouse/dispatchinfo`,
        method: 'get',
        params
    });
};

// 公司外线路
export const updateOutLineContract = (data) => {
    return request({
        url: `/api-tms/dispatch/updateOutLineContract`,
        method: 'put',
        data
    });
};

// 打印
export const getDispathOrderWarehouse = (params) => {
    return request({
        url: `/api-tms/dispatch/print`,
        method: 'get',
        params
    });
};

// 蓝月亮打印
export const dispatchBluemoonPrint = (params) => {
    return request({
        url: `/api-tms/dispatch/bluemoon/print`,
        method: 'get',
        params
    });
};

// 供应商保存
export const getDispathOrderPreservation = (data) => {
    return request({
        url: `/api-tms/dispatch/updateeditdispatchinfo`,
        method: 'put',
        data
    });
};

// 打印（次数）
export const updataPrintTimes = (data) => {
    return request({
        url: `/api-tms/dispatch/updatePrintTimes`,
        method: 'put',
        data
    });
};

// 运输单状态数据字典接口（用于本地存储）
export const taskStatuLists = (data) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=TRANSPORT_STATUS`,
        method: 'get',
        data
    });
};
// 设备绑定/修改/解绑
export const saveupdatecancledevice = (data) => {
    return request({
        url: `/api-tms/dispatch/saveupdatecancledevice`,
        method: 'put',
        data
    });
};
// 导出
export const dispatchExport = (data) => {
    return request({
        url: `/api-tms/export/dispatch`,
        method: 'post',
        data
    });
};
// 成本校验
export const judgeCost = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeCost`,
        method: 'post',
        data
    });
};
// 成本审批
export const startCostIflowApproval = (data) => {
    return request({
        url: `/api-tms/dispatch/startCostIflowApproval`,
        method: 'post',
        data
    });
};
// 根据发车单查运输单
export const getTaskData = (data) => {
    return request({
        url: `/api-tms/transport/list/sort`,
        method: 'post',
        data
    });
};

// 园区预约--查询装卸货信息列表
export const queryReservationLoadInfo = data => {
    return request({
        url: `/api-antms/transport/transport/queryReservationLoadInfo`,
        method: 'post',
        data
    });
};

// 园区预约--查询预约时间段接口
export const queryReservationTime = data => {
    return request({
        url: `/api-antms/transport/transport/queryReservationTime`,
        method: 'post',
        data
    });
};

// 园区预约--确定
export const reservationConfirm = data => {
    return request({
        url: `/api-antms/transport/transport/reservationConfirm`,
        method: 'post',
        data
    });
};

// 园区预约--更新
export const reservationUpdate = data => {
    return request({
        url: `/api-antms/transport/transport/reservationSync`,
        method: 'post',
        data
    });
};

// 园区预约--取消预约
export const reservationCancel = data => {
    return request({
        url: `/api-antms/transport/transport/reservationCancel `,
        method: 'post',
        data
    });
};

// 在途路由查询历史记录
export const getOnTheWayData = (data) => {
    return request({
        url: `/api-tms/transitTracking/queryTrackingByDispatchNoAndTaskNo`,
        method: 'post',
        data
    });
};
// 在途路由保存
export const saveOnTheWayData = (data) => {
    return request({
        url: `/api-tms/transitTracking/saveTransitTracking`,
        method: 'post',
        data
    });
};
// 判断是否修改了详细地址
export const addressDetailHasChange = (data) => {
    return request({
        url: `/api-tms/transport/addressDetailHasChange`,
        method: 'post',
        data
    });
};
// 更改重量
export const updateVolumnWeight = (data) => {
    return request({
        url: `/api-tms/dispatch/updateVolumnWeight`,
        method: 'post',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};

// 整车异常发车原因登记接口
export const registerAbnormalDepartReason = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/registerAbnormalDepartReason`,
        method: 'post',
        data
    });
};
// 根据发车单获取运输单
export const getTaskList = (data) => {
    return request({
        url: `/api-tms/transport/ext/query`,
        method: 'post',
        data
    });
};
// 取消装货
export const cancelLoadStatus = dispatchNo => {
    return request({
        url: `/api-antms/transport/transport/cancelLoadStatus?dispatchNo=${dispatchNo}`,
        method: 'get'
    });
};
// 判断发车异常卡控弹框接口
export const isNeedExceptionRemarks = data => {
    return request({
        url: `/api-antms/transport/dispatch/isNeedExceptionRemarks`,
        method: 'post',
        data
    });
};

// 发车异常保存接口
export const addExceptionRemarks = data => {
    return request({
        url: `/api-antms/transport/dispatch/addExceptionRemarks`,
        method: 'post',
        data
    });
};

// 发车人工操作校验接口
export const checkLclOperate = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/checkLclOperate`,
        method: 'post',
        data
    });
};

// 发车操作原因保存接口
export const updateDispatchLclOperateReason = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/updateDispatchLclOperateReason`,
        method: 'post',
        data
    });
};

// 运输单抵达人工操作校验接口
export const checkTransportLclOperate = (data) => {
    return request({
        url: `/api-antms/transport/dispatchLcl/checkLclOperate`,
        method: 'post',
        data
    });
};

// 根据运输单抵达操作原因保存接口
export const updateArrivalOperateReasonByTaskNo = data => {
    return request({
        url: `/api-antms/transport/transportLcl/updateArrivalOperateReasonByTaskNo`,
        method: 'post',
        data
    });
};

// 根据站点到车或抵达人工操作校验接口
export const checkSiteAddressLclOperate = (data) => {
    return request({
        url: `/api-antms/transport/transportLcl/checkSiteAddressLclOperate`,
        method: 'post',
        data
    });
};

// 根据站点到车或抵达操作原因保存接口
export const updateTransportLclArriveOperateReason = data => {
    return request({
        url: `/api-antms/transport/transportLcl/updateTransportLclArriveOperateReason`,
        method: 'post',
        data
    });
};
